(function() {
    $("html").click(function(e) {
        if ($("body").hasClass("user-menu-active")) {
            if (!$(e.target).parents(".dropdown-user-menu").length) {
                $("body").toggleClass("user-menu-active");
                $(".dropdown-user-menu").toggleClass("show-dropdown");
            }
        } else {
            if ($(e.target).parents(".user-login-menu-trigger").length) { 
                $("body").toggleClass("user-menu-active");
                $(".dropdown-user-menu").toggleClass("show-dropdown");
            }
        }
    });

    function hideAtcForFreeProducts() {
        document
        .querySelectorAll(
            ".st-wishlist-details_main .st-product-card"
        )
        .forEach(function (card) {
            if (!card.querySelector(".st-free-price")) return;
            var btn = card.querySelector(".st-atc-button");
            if (!btn) return;
            var text = btn.textContent.trim().toLowerCase();
            var isOutOfStock =
            text.indexOf("out of stock") !== -1 ||
            text.indexOf("sold out") !== -1 ||
            text.indexOf("notify") !== -1;
            if (isOutOfStock) {
            card.classList.remove("st-hide-atc");
            } else {
            card.classList.add("st-hide-atc");
            }
        });
    }

    var observer = new MutationObserver(function () {
        hideAtcForFreeProducts();
    });

    observer.observe(document.body, { childList: true, subtree: true });
})();





// (() => {
 
//     $('html').click(function(e) {  
        
//             if( 
//                 $(e.target).hasClass('dropdown-user-menu') || 
//                 $(e.target).hasClass('user-login-menu-trigger') || 
//                 $(e.target).closest('div').hasClass('user-login-menu-trigger') || 
//                 $(e.target).closest('.js-header-dropdown-user-menu').hasClass('dropdown-user-menu')  
//             ){
                
//                 $('.dropdown-user-menu').addClass('show-dropdown');
//                 $('body').addClass('user-menu-active');
                
//             }else{
//                 if($('body').hasClass('user-menu-active')){
//                     e.preventDefault();
//                 }
//                 $('.dropdown-user-menu').removeClass('show-dropdown');
//                 $('body').removeClass('user-menu-active');
                
//             }

//             if(document.querySelector('body').hasClass('cart-active')){
//                 if(!$(e.target).closest('form').hasClass('cart-form')){                  
//                   e.preventDefault();
//                 }
                
//             }

            
            
        
//     });  

 

// })();


